const prettify = (value) => {
  if (!value) return ""
  return value
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

const ROOM_TYPE_AR = {
  all: "الكل",
  bathroom: "الحمام",
  bedroom: "غرف النوم",
  garden: "الحديقة",
  kids_room: "غرفة الأطفال",
  office: "المكتب",
  kitchen: "المطبخ",
  dining: "غرفة الطعام",
  entrance: "المدخل",
  living_room: "الصالة",
  gaming_room: "غرفة الألعاب",
}

const DECOR_STYLE_AR = {
  all: "الكل",
  modern: "حديث",
  classy: "راقي",
  modern_classic: "كلاسيكي حديث",
  rustic_modern: "ريفي حديث",
  contemporary: "معاصر",
  boho: "بوهيمي",
  industrial: "صناعي",
  eclectic: "انتقائي",
  shabby_chic: "شيك مهترئ",
  zen: "زن",
}

const THEME_AR = {
  all: "الكل",
  dark: "غامق",
  light: "فاتح",
}

const CREATIVITY_AR = {
  balanced: "متوازن",
  creative: "إبداعي",
  standard: "قياسي",
  conservative: "محافظ",
  precise: "دقيق",
}

export function translateRoomType(value, lang = "en") {
  if (!value) return ""
  if (lang !== "ar") return prettify(value)
  const normalized = value.toString().trim().toLowerCase()
  return ROOM_TYPE_AR[normalized] || value
}

export function translateDecorStyle(value, lang = "en") {
  if (!value) return ""
  if (lang !== "ar") return prettify(value)
  const normalized = value.toString().trim().toLowerCase()
  return DECOR_STYLE_AR[normalized] || value
}

export function translateTheme(value, lang = "en") {
  if (!value) return ""
  if (lang !== "ar") return prettify(value)
  const normalized = value.toString().trim().toLowerCase()
  return THEME_AR[normalized] || value
}

export function translateCreativity(value, lang = "en") {
  if (!value) return ""
  if (lang !== "ar") return prettify(value)
  const normalized = value.toString().trim().toLowerCase()
  return CREATIVITY_AR[normalized] || value
}

export function parseColorPalette(value) {
  if (!value) return []
  if (Array.isArray(value)) {
    return value
      .map((color) => (typeof color === "string" ? color.trim() : ""))
      .filter(Boolean)
  }
  if (typeof value === "string") {
    return value
      .split(",")
      .map((color) => color.trim())
      .filter(Boolean)
  }
  return []
}

/** Merge top-level generation fields with nested presets object. */
export function getGenerationPresetFields(gen) {
  if (!gen || typeof gen !== "object") {
    return {
      room_type: null,
      decor_style: null,
      room_theme: null,
      color_palette: null,
      creativity: null,
    }
  }

  const nested =
    gen.presets && typeof gen.presets === "object" && !Array.isArray(gen.presets)
      ? gen.presets
      : {}

  return {
    room_type: gen.room_type ?? nested.room_type ?? null,
    decor_style: gen.decor_style ?? nested.decor_style ?? null,
    room_theme: gen.room_theme ?? nested.room_theme ?? null,
    color_palette: gen.color_palette ?? nested.color_palette ?? null,
    creativity: gen.creativity ?? nested.creativity ?? null,
  }
}
